/**
 * Tracking Event Constants
 * Centralized event names for Amplitude tracking
 */

export const TRACKING_EVENTS = {
    // Authentication Events
    AUTH: {
        SIGN_IN_FORM_SUBMITTED: 'sign_in_form_submitted',
        SIGN_UP_FORM_SUBMITTED: 'sign_up_form_submitted',
        SIGN_IN_FORM_ERROR: 'sign_in_form_error',
        SIGN_UP_FORM_ERROR: 'sign_up_form_error',
        LOGOUT_CLICKED: 'logout_clicked',
        LOGIN_SUCCESS: 'login_success',
        REGISTRATION_SUCCESS: 'registration_success',
        SSO_CLICKED: 'sso_clicked',
    },

    // Banner Events
    BANNERS: {
        // Previous: 'providers_banner_click' (for provider banners)
        // Previous: 'get_matched_small' / 'get_matched_big' (for match forms)
        CLICKED: 'banner_clicked',
        PROMO_VIEWED: 'promo_banner_viewed',
        PROMO_CTA_CLICKED: 'promo_banner_cta_clicked',
        PROMO_CLOSED: 'promo_banner_closed',
    },

    // Provider Events
    PROVIDERS: {
        // Previous: 'provider_book_a_consultation' (button click) + 'provider_ecom_cta_clicked'
        CTA_CLICKED: 'provider_cta_clicked',
        // Previous: 'provider_book_a_consultation_sent' (same name, now uses constant)
        BOOK_CONSULTATION_SENT: 'provider_book_a_consultation_sent',
        CARD_CLICKED: 'provider_card_clicked',
        CONTACT_CLICKED: 'provider_contact_clicked',
        FILTERED: 'providers_filtered',
        // Booking flow tracking (via Amelia JS hooks)
        BOOKING_STEP: 'provider_booking_step',
        BOOKING_COMPLETED: 'provider_booking_completed',
        // Note: Provider page views now use ENGAGEMENT.PAGE_VIEW with page_type='provider_page'
        // Previous: 'provider_page_view'
        // Provider page scrolls now use ENGAGEMENT.PAGE_SCROLL with page_type='provider_page'
        // Previous: 'provider_page_scroll'
    },

    // Form Events
    FORMS: {
        NEWSLETTER_SUBSCRIPTION_ATTEMPTED: 'newsletter_subscription_attempted',
        FORM_SUBMITTED: 'form_submitted',
    },

    RESERVE: {
        OPEN: 'reserve_open',
        STEP1_SUBMIT: 'reserve_step1_submit',
        STEP2_VIEW: 'reserve_step2_view',
        THANK_YOU_VIEW: 'reserve_thank_you_view',
    },

    // Test Events
    TEST: {
        REPORT_VIEWED: 'test_report_viewed',
        ARTICLE_CLICKED: 'article_clicked_from_report',
        SEE_ALL_ARTICLES_CLICKED: 'see_all_articles_clicked',
        INVITE_OTHERS_CLICKED: 'invite_others_clicked',
        TAKE_ANOTHER_TEST_CLICKED: 'take_another_test_clicked',
        FIND_PROVIDER_TEST_BANNER_CLICKED: 'find_a_provider_test_banner_clicked',
        CATEGORY_ARROW_CLICKED: 'category_arrow_clicked',
        SEE_ALL_TESTS_CLICKED: 'see_all_tests_clicked',
        TEST_CLICKED: 'test_clicked_from_report',
        GENDER_SELECTED: 'test_landing_gender_selected',
        START_CLICKED: 'test_landing_start_clicked',
    },

    // Navigation Events
    NAVIGATION: {
        HEADER_CTA_CLICKED: 'header_cta_clicked',
        TABLE_OF_CONTENTS_CLICKED: 'toc_clicked',
    },

    // Engagement Events
    ENGAGEMENT: {
        // Page Tracking
        // Previous: 'provider_page_view' (now uses page_type='provider_page')
        PAGE_VIEW: 'page_viewed',
        // Previous: 'provider_page_scroll' (now uses page_type='provider_page')
        PAGE_SCROLL: 'page_scrolled',
        // Social Media
        DISCORD_BUTTON_CLICKED: 'discord_button_clicked',
        FACEBOOK_BUTTON_CLICKED: 'facebook_button_clicked',
        WHATSAPP_BUTTON_CLICKED: 'whatsapp_button_clicked',
        CONTENT_SHARED: 'content_shared',
        // User Interactions
        REACTION_CLICKED: 'reaction_clicked',
        FEEDBACK_VOTE_SUBMITTED: 'feedback_vote_submitted',
        FEEDBACK_DETAILS_SUBMITTED: 'feedback_details_submitted',
        // UI Interactions
        POPUP_OPENED: 'popup_opened',
        POPUP_CLOSED: 'popup_closed',
        FAQ_ITEM_CLICKED: 'faq_v2_item_clicked',
    },
};

